import request from '@/utils/request'

//获取人物大家数据
export function PopularsciencePepole() {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/PopularsciencePepole',
        method: 'Post',
        data: {}
    })
}

//获取科普视频
export function GetScienceVideo() {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetScienceVideo',
        method: 'Post',
        data: {}
    })
}


//获取科普咨询数据
export function GetListPopularInformation(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetListPopularInformation',
        method: 'Post',
        params: data
    })
}


//根据ID获取科普咨询的信息
export function GetPopularInformationByID(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetPopularInformationByID',
        method: 'Post',
        params: data
    })
}


//根据ID获取科普大家的信息
export function GetScienceByID(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetScienceByID',
        method: 'Post',
        params: data
    })
}


//调用知网接口获取科普大家的信息
export function GetScienceByzhiwang(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetScienceByzhiwang',
        method: 'Post',
        params: data
    })
}



// WEBPACK FOOTER //
// ./src/api/science.js